import React from "react";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { get, filter } from "lodash";

import { fetchGet, fetchPost } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import ProfileLink from "../../Common/ProfileLink";
import AddVerification from "../../Profiles/AddVerification";
import ProfileSurvey from "../../Profiles/ProfileSurvey/ProfileSurvey";

import { updateOneLog } from "../../../actions/siteEntranceExit/tabs";

import { LANGUAGES } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const LogDetailsVerification = (props) => {
  const { dispatch, section, log, language, tabs } = props;
  const [surveys, setSurveys] = React.useState();

  React.useEffect(() => {
    getSurveys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(log)]);

  const getSurveys = async () => {
    let preSurvey, lastSurvey, referenceSurvey;
    if (get(log, ["verification"])) {
      preSurvey = get(
        filter(get(log, ["verification", "events"]), (e) =>
          [91].includes(get(e, ["type", "id"]))
        ),
        [0]
      );
      lastSurvey = get(
        filter(get(log, ["verification", "events"]), (e) =>
          [81].includes(get(e, ["type", "id"]))
        ),
        [0]
      );
      if (get(preSurvey, ["reference_event_id"])) {
        referenceSurvey = await fetchGet(
          `events/${get(preSurvey, ["reference_event_id"])}`
        );
      }
    }
    setSurveys({
      preSurvey,
      lastSurvey,
      referenceSurvey,
    });
  };

  const onSubmitVerification = async (
    verificationEventGroup,
    surveyEvent,
    lukeActionEvent,
    verification
  ) => {
    try {
      verificationEventGroup.parent_id = get(log, ["id"]);
      let eventGroup = await fetchPost("event_groups", verificationEventGroup);
      surveyEvent.event_group_id = get(eventGroup, ["id"]);
      lukeActionEvent.event_group_id = get(eventGroup, ["id"]);
      await fetchPost("events", surveyEvent);
      await fetchPost("events", lukeActionEvent);
      dispatch(updateOneLog(section, tabs.tabIndex, tabs.openFrom, log.id));
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Grid container direction="column" wrap="nowrap">
        <ProfileLink
          profile={get(log, ["human", "profile"])}
          score={get(log, ["detections", "human", "luke_index"])}
          overriden={get(log, ["human", "overriden"])}
          type="human"
        />
        <Grid
          item
          style={{
            marginTop: "20px",
            marginLeft: "30px",
          }}
        >
          <AddVerification
            profile={get(log, ["human", "profile"])}
            language={language}
            refreshHistory={() =>
              dispatch(
                updateOneLog(section, tabs.tabIndex, tabs.openFrom, log.id)
              )
            }
            isMe={false}
            onSubmit={onSubmitVerification}
            noVerificationSubmit
            noConfirmation
            companies={[
              get(log, ["complete", "events", 0, "zone", "company", "id"]),
            ]}
            sites={[get(log, ["complete", "events", 0, "zone", "site", "id"])]}
            zones={[get(log, ["complete", "events", 0, "zone", "id"])]}
          />
        </Grid>
        <Grid
          style={{
            marginLeft: "30px",
          }}
        >
          <ProfileSurvey
            surveys={surveys}
            profileId={get(log, ["human", "profile", "id"])}
            language={language}
            eventGroupId={get(log, ["detections", "human", "id"])}
            onlyEdit={{
              onClose: () => {
                dispatch(
                  updateOneLog(section, tabs.tabIndex, tabs.openFrom, log.id)
                );
              },
            }}
            hide={{
              new: true,
            }}
          />
        </Grid>
      </Grid>
      {props.powerUserMode && (
        <Box
          style={{
            position: "absolute",
            bottom: "82px",
            right: "56px",
            fontSize: "0.875em",
            color: colors.black38,
          }}
        >
          {I18n.get("site_eventGroupId") + " "}
          <span style={{ fontStyle: "italic" }}>
            {get(log, ["verification", "id"])}
          </span>
        </Box>
      )}
    </>
  );
};

LogDetailsVerification.propTypes = {
  log: PropTypes.object.isRequired,
  language: PropTypes.oneOf(LANGUAGES),
};

export default connect()(LogDetailsVerification);
